export default "__VITE_ASSET__BsJpaeOW__"